module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warning"
  }, [_c('el-dialog', {
    attrs: {
      "visible": _vm.warning.visible,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.$set(_vm.warning, "visible", $event)
      }
    }
  }, [_c('div', [(_vm.warningCount === 1) ? _c('p', [_vm._v("您需同意《美团收银服务协议》和《隐私政策》方可使用本软件。")]) : _c('p', [_vm._v("现将退出系统，您可以再次登录，同意《美团收银服务协议》和《隐私政策》后，继续使用，谢谢！")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.warningCount === 1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("我知道了")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleLogOut
    }
  }, [_vm._v("我知道了")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9700de06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui/AgreementSign/Warning.vue
// module id = 190
// module chunks = 0